import React, { useRef, useCallback, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";

import LoginService from "../service/LoginService";

const loginService = new LoginService(); // Create an instance of LoginService

export const ValidateEmail = (props) => {
    const [loading, setLoading] = useState(false);
    const [activeDialog, setActiveDialog] = useState(false);
    const toast = useRef(null);
    const history = useHistory();

    let result = {
        message: {
            login: "",
            message: ""
        }
    }

    const [data, setData] = useState(result);

    const verifyEmail = useCallback(() => {
        try {

            setLoading(true)

            loginService.verify(props.verifyToken).then(data => {
                setData(data.data);
                setLoading(false);
                setActiveDialog(true);
            });


            // Handle successful login, such as updating state or navigating to another page
        } catch (error) {
            // Handle login error, such as displaying an error message to the user
            setLoading(false)
            if (error.status === 401) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Erro ao validar email. Token Inválido.' });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Erro ao validar email' });
            }
            console.error('Login error:', error);
        }
    });

    useEffect(() => {
        if (data.message.message === '')
            verifyEmail()
    }, [data, verifyEmail])


    const hideModalActive = () => {
        setActiveDialog(false);
    }

    const handleClose = () => {
        window.location.href = 'https://www.starblack.app.br';
    }

    const activeDialogFooter = (
        <>
            <Button label="Fechar" icon="pi pi-check" className="p-button-text" onClick={handleClose} />
        </>
    );

    return (
        <div className="login-body">
            <Toast ref={toast} />
            <div style={{ width: '30%' }} className="login-image">

            </div>
            <div className="login-panel p-fluid">
                <div className="flex flex-column">
                    <div className="flex align-items-center mb-6 logo-container">
                        <h1>StarBlack</h1>
                    </div>
                    <div className="flex align-items-center mb-6 logo-container">
                        <h2>{loading ? "Validando email..." : "Ok"}</h2>
                    </div>
                </div>

                <div className="login-footer flex align-items-center">
                    <div className="flex align-items-center login-footer-logo-container">
                        <h4>StarBlack</h4>
                    </div>
                    <span>Copyright 2024</span>
                </div>
            </div>

            <Dialog visible={activeDialog} style={{ width: '450px' }} header="Validar e-mail" modal footer={activeDialogFooter} onHide={hideModalActive}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-check mr-3" style={{ fontSize: '2rem' }} />
                    <span>E-mail: {data.message.login} <br /><br /> {data.message.message}</span>
                </div>
            </Dialog>
        </div>
    )
}
